export default "__VITE_ASSET__oIr$nIh9__"